<script setup>
const props = defineProps({
  action: {
    type: Object,
    required: true
  },
  data: {
    type: Object,
    required: true
  }
})

const showNotification = inject('showNotification')

const loading = ref(false)

const emit = defineEmits(['close'])

const cancelOffer = async () => {
  loading.value = true

  const input = {
    updateOfferStateInput: {
      vin: props.data.vehicle.vin,
      inventoryId: props.data.id,
      state: 'OfferCancelledByUser',
      price: props.data.acvValues.guarantee
    }
  }

  try {
    const response = await props.action.fetch(input)
    const offerCanceled = response.data.updateOfferState
    emit('close', offerCanceled)
  } catch {
    showNotification('Failed to cancel the offer.')
  } finally {
    loading.value = false
  }
}

const cancelAction = () => {
  emit('close')
  props.action.abort()
}
</script>

<template>
  <VCard class="rounded-xl">
    <VCardTitle class="text-h6">
      Cancel ACV Guarantee Offer
    </VCardTitle>

    <VCardText class="text-body-2">
      Cancel the ACV Guarantee offer and inspection request.
    </VCardText>

    <VCardActions class="pa-4 pt-0">
      <VSpacer />
      <VBtn
        color="primary"
        variant="tonal"
        class="rounded-pill px-4"
        @click="cancelAction"
      >
        No, do not Cancel
      </VBtn>
      <VBtn
        color="error"
        variant="tonal"
        class="rounded-pill px-4"
        :loading="loading"
        @click="cancelOffer"
      >
        Yes, Cancel ACV Guarantee Offer
      </VBtn>
    </VCardActions>
  </VCard>
</template>
